{
  "wellbore_uwi": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "UWI",
      "width": 175,
    },
  },
  "licensee": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Licensee",
      "isShownByDefault": true,
    },
  },
  "on_prod_date": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "On Production Date",
      "width": 80,
      "isShownByDefault": true,
    },
  },
  "oil_and_condensate_bbl_per_day": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d",
    },
    "ui": {
      "label": "Oil + Condensate",
      "width": 80,
      "isShownByDefault": true,
    },
  },
  "oil_bbl_per_day": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d",
    },
    "ui": {
      "label": "Oil",
      "width": 80,
      "isShownByDefault": true,
    },
  },
  "condensate_bbl_per_day": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d",
    },
    "ui": {
      "label": "Condensate",
      "width": 80,
      "isShownByDefault": true,
    },
  },
  "total_production_boe_per_day": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "boe/d",
    },
    "ui": {
      "label": "Total",
      "width": 80,
      "isShownByDefault": true,
    },
  },
  "gas_mcf_per_day": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "mcf/d",
    },
    "ui": {
      "label": "Gas",
      "width": 80,
      "isShownByDefault": true,
    },
  },
  "total_production_boe": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "boe",
    },
    "ui": {
      "label": "Total",
      "width": 80,
      "isShownByDefault": true,
    },
  },
  "type": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Type",
      "width": 80,
      "isShownByDefault": true,
    },
  },
  "formation": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Formation",
      "width": 80,
      "isShownByDefault": true,
    },
  },
  "field_name": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Field",
      "width": 80,
      "isShownByDefault": true,
    },
  },
  "production_hours": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "hours",
    },
    "ui": {
      "label": "Producing Hours",
      "width": 80,
      "isShownByDefault": true,
    },
  },
  "total_bbl_oil": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl",
    },
    "ui": {
      "label": "Oil Cumulative",
      "width": 80,
      "isShownByDefault": true,
    },
  },
}
